import React from 'react';
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";

import { pltw } from './images';

import {makeStyles} from "@material-ui/core";

import './styles/pltwNavBar-styles.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // marginBottom: '10px'
  },
  appBar: {
    backgroundColor: '#ffffff'
    // border: '2px solid black'
  },
  title: {
    flexGrow: 1,
    color: '#F6EDD6',
    marginLeft: '20px',
    alignSelf: 'center',
  },
  logo: {
    height: '50px',
    // cursor: 'pointer'
  },
  zeroWasteLogo: {
    maxHeight: '50px',
    maxWidth: '50vw'
  },
  sectionDesktop: {
    flexGrow: 1,
    display: 'none',
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    flexGrow: 1,
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },


}));

const PltwNavBarLogin = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar>

          <div className={classes.sectionMobile}>
            <img src={pltw} className={classes.logo} alt='pltw logo' />
            <div className={classes.title} />
            <div className='nav-subtitle-mobile'>
              <p>Zero Waste: A Unique PLTW Experience</p>
            </div>
          </div>

          <div className={classes.sectionDesktop}>
            <img src={pltw} className={classes.logo} alt='pltw logo' />
            <div className={classes.title} />
            <div className='nav-subtitle'>
              <p>Zero Waste: A Unique PLTW Experience</p>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default PltwNavBarLogin;
